import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import careerClasses from './careersStyles'


function CareersBuild() {
  const globalClasses = globalUseStyles();
  const careerStyles = careerClasses();
  return (
    <ThemeProvider theme={theme}>
      <Container id='jobopenings' className={"careersBuildStyle"} maxWidth={false} component="section">
         <Grid className={globalClasses.containerVertPaddingLg} container>
            <Grid className={globalClasses.containerSmall} container >
               <Grid item xs={12} md={12}  >
                  <Typography variant="h1">Build Your Career</Typography>
               </Grid>
               <Grid className={careerStyles.careerListings} container >
                  <Grid className={globalClasses.selfCentered} item xs={12} md={9}  >
                     <Typography className={globalClasses.noMargin} variant="h4">Dev Ops Engineer</Typography>
                  </Grid>
                  <Grid className={globalClasses.selfCentered} item xs={12} md={2}  >
                     <Typography className={globalClasses.noMargin} variant="body2">Remote</Typography>
                  </Grid>
                  <Grid item xs={12} md={1} className={careerStyles.viewButton} >
                     <Button variant="outlined" color="inherit" className={'secondaryButton'}>View</Button>
                  </Grid>
               </Grid>
               <Grid className={careerStyles.careerListings} container >
                  <Grid className={globalClasses.selfCentered} item xs={12} md={9}  >
                     <Typography className={globalClasses.noMargin} variant="h4">Sec Ops Engineer</Typography>
                  </Grid>
                  <Grid className={globalClasses.selfCentered} item xs={12} md={2}  >
                     <Typography className={globalClasses.noMargin} variant="body2">Remote</Typography>
                  </Grid>
                  <Grid item xs={12} md={1} className={careerStyles.viewButton} >
                  <Button variant="outlined" color="inherit" className={'secondaryButton'}>View</Button>
                  </Grid>
               </Grid>
               <Grid className={careerStyles.careerListings} container >
                  <Grid className={globalClasses.selfCentered} item xs={12} md={9}  >
                     <Typography className={globalClasses.noMargin} variant="h4">Senior Dev Ops Engineer</Typography>
                  </Grid>
                  <Grid className={globalClasses.selfCentered} item xs={12} md={2}  >
                     <Typography className={globalClasses.noMargin} variant="body2">Remote</Typography>
                  </Grid>
                  <Grid item xs={12} md={1} className={careerStyles.viewButton} >
                  <Button variant="outlined" color="inherit" className={'secondaryButton'}>View</Button>
                  </Grid>
               </Grid>
            </Grid>
         </Grid>
      </Container>
     </ThemeProvider>
  );
};

export default CareersBuild;